import React from 'react';

const HourglassIcon = () => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.666504L0.00833352 5.6665L3.33333 8.99984L0.00833352 12.3415L0 17.3332H10V12.3332L6.66667 8.99984L10 5.67484V0.666504H0ZM8.33333 12.7498V15.6665H1.66667V12.7498L5 9.4165L8.33333 12.7498Z"
        fill="#575757"
      />
    </svg>
  );
};

export default HourglassIcon;
